export const NUMBER_OF_ROWS_COLUMNS = 3;
export const SITE_PRIMARY_COLOR = '#bc2152';
export const SITE_PRIMARY_COLOR_DARK = '#831739';
export const SITE_SECONDARY_COLOR = '#fffbf3';
export const MOBILE_WIDTH = 900;
export const MOBILE_PORTRAIT_WIDTH = 480;
export enum LanguageEnum {
    ENGLISH = 'en',
    DEUTSCH = 'de',
    日本語 = 'ja',
    中文 = 'zh',
    Māori = 'mi'
}
